<ul class="eventq-resolve-queue-skeleton-list" aria-busy="true" aria-label="Loading queue events">
  @for (priority of skeletonPriorities(); track $index) {
    <li>
      <eventq-resolve-queue-row [priority]="priority" [loading]="true" />
    </li>
  }
</ul>
